import React, { useState } from 'react';
import { Loader } from '../../../../../../Common';
import { Alert, Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import { useHistory } from 'react-router-dom';
import { CustomCard } from '../Comman';
import { FaMapMarkerAlt, FaPlaneDeparture, FaTags } from 'react-icons/fa';
import { MdPersonAddAlt1 } from 'react-icons/md';
import StepCard from './Components/StepCard';
import airport from '../../../../../../../assets/images/airports.svg';
import addUser from '../../../../../../../assets/images/add-user.svg';
import tags from '../../../../../../../assets/images/tags.svg';
import zone from '../../../../../../../assets/images/zone.svg';
import { ChevronLeft } from 'react-feather';

const ClientPricingFlow = ({ state, setFormCount }) => {
  const history = useHistory();

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const steps = [
    { number: '1', label: 'Select Airport', icon: airport, color: 'primary' },
    { number: '2', label: 'Select Zone', icon: zone, color: 'info' },
    { number: '3', label: 'Select Vendor', icon: addUser, color: 'warning' },
    { number: '3.1', label: 'Add Vendor Price', icon: tags, color: 'purple' },
    { number: '4', label: 'Add Client Zone', icon: zone, color: 'info' },
    { number: '4.1', label: 'Add Client Price', icon: tags, color: 'purple' },
  ];

  const handleSubmit = () => {
    setFormCount((prev: number) => prev + 1);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Program Onboarding`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Program', 'Onboarding', 'Pricing Flow']}
            />
          </div>

          {/* <Filter
            filterHandler={filterSubmitHandler}
            bookingType={bookingType}
            approvalRequestTypeHandler={approvalRequestTypeHandler}
            modification={modification}
          /> */}
        </div>

        <Card>
          <CardHeader>
            <h5 className="m-0 fw-semibold">Configure Airport Transfer for {state?.client?.name}</h5>
          </CardHeader>
          <CardBody className="pb-5">
            <h3 className="text-center mt-3 fw-semibold">Getting Started</h3>
            <p className="text-center fs-14">Complete the below steps to add Airport transfer to this program</p>

            <Row className="mt-4">
              {steps.map((step, index) => (
                <Col md="4" key={index}>
                  <StepCard {...step} />
                </Col>
              ))}
            </Row>

            <Alert color="info" className="mt-4">
              <strong>Getting Started</strong>
              <br />
              Begin by selecting the airports you want to configure. You can jump between steps as needed, and your progress will be automatically
              saved. Use the step navigation at the top to move between sections.
            </Alert>
          </CardBody>
        </Card>
        <div className="d-flex justify-content-between">
          <Button
            onClick={() => setFormCount((prev: number) => prev - 1)}
            color="light"
            className="d-flex align-items-center gap-1 px-3 py-2"
            style={{
              backgroundColor: '#E9EBEC', // light gray
              color: '#404B7C', // navy/dark blue
              fontWeight: 500,
              boxShadow: 'none',
              border: 'none',
            }}
          >
            <ChevronLeft size={18} />
            Back
          </Button>
          <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default ClientPricingFlow;
